import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useTranslation } from 'react-i18next';
import { getAllTitles } from 'src/shared/services/titleService';
import { ControlledMultiPickerWithCategory } from 'src/shared/components/form/controlledMultiPickerWithCategory';
import { Grid } from '@mui/material';
import { ControlledCheckboxNew } from 'src/shared/components/form/controlledCheckboxNew';
import { TitlePickerItem } from '../models/titlePickerItem';

export const MemberAdvancedSearchTitle = () => {
  const { t } = useTranslation(['common']);
  const isMounted = useIsMounted();

  return (
    <Grid container>
      <Grid item xs>
        <ControlledMultiPickerWithCategory<TitlePickerItem>
          name='titleIds'
          limitTags={2}
          componentWidth='100%'
          callback={(x) => {
            ConsoleHelper.log(x);
          }}
          showCategory
          fetchMethod={async () => {
            try {
              const result = await getAllTitles(null);
              if (isMounted()) {
                ConsoleHelper.log('result', result);
                const titleArray: TitlePickerItem[] = [];
                result.data.results
                  .sort((a, b) => (a.type > b.type ? 0 : -1))
                  .forEach((item) => {
                    // Pushar in alla associations
                    titleArray.push({
                      code: item.title_id,
                      parentName: item.type === 0 ? t('member:memberAdvancedSearch.boardTitle') : t('member:memberAdvancedSearch.electedTitle'),
                      parentCode: item.title_id,
                      isParent: false,
                      name: item.title,
                    });
                  });
                return titleArray;
              }
            } catch (e) {
              if (isMounted()) {
                ConsoleHelper.log(e);
              }
            }

            return [];
          }}
          label={t('member:memberAdvancedSearch.titleIds')}
        />
      </Grid>
      <Grid item xs='auto' sx={{ pl: 2 }}>
        <ControlledCheckboxNew name='includeResignedTitles' label={t('member:memberAdvancedSearch.includeResignedTitles')} />
      </Grid>
    </Grid>
  );
};
